import React, { useState } from 'react';
import { Landmark, BarChart3, TrendingUp, Globe, Lightbulb, Wallet, Gift, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function QueIncluye() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const blocks = [{
    title: 'MÓDULO I: FUNDAMENTOS DE LA INVESTIGACIÓN EN CIENCIAS SOCIALES',
    icon: <Landmark className="text-blue-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-161" />,
    color: 'bg-blue-100',
    items: ['Qué es investigar', 'Conocimiento científico y conocimiento cotidiano', 'Ciencias Sociales y su especificidad', 'Enfoque cuantitativo, cualitativo y mixto', 'Problema de investigación', 'Objetivos e hipótesis', 'Variables y operacionalización']
  }, {
    title: 'MÓDULO II: DISEÑO METODOLÓGICO CUANTITATIVO',
    icon: <BarChart3 className="text-green-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-162" />,
    color: 'bg-green-100',
    items: ['Tipos de variables', 'Construcción de encuestas', 'Muestreo', 'Tabulación de datos', 'Estadística descriptiva', 'Correlación de Pearson', 'Interpretación de resultados', 'Errores frecuentes en análisis cuantitativo']
  }, {
    title: 'MÓDULO III: DISEÑO METODOLÓGICO CUALITATIVO',
    icon: <TrendingUp className="text-amber-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-163" />,
    color: 'bg-amber-100',
    items: ['Entrevista semiestructurada', 'Observación sistemática', 'Codificación abierta y axial', 'Construcción de categorías', 'Análisis interpretativo', 'Integración cuantitativo–cualitativa']
  }, {
    title: 'MÓDULO IV: ANÁLISIS MULTIVARIABLE Y RIGOR METODOLÓGICO',
    icon: <Globe className="text-red-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-164" />,
    color: 'bg-red-100',
    items: ['Variables intervinientes', 'Modelo multivariable conceptual', 'Interpretación avanzada de correlación', 'Introducción a p-valor e intervalo de confianza', 'Reconocimiento de límites metodológicos', 'Redacción académica profesional']
  }, {
    title: 'MÓDULO V: PROYECTO INTEGRADOR COMPLETO',
    icon: <Lightbulb className="text-purple-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-165" />,
    color: 'bg-purple-100',
    items: ['Estructura formal del proyecto', 'Redacción del informe final', 'Modelo de presentación oral', 'Defensa del trabajo', 'Rúbrica profesional detallada']
  }, {
    title: 'MÓDULO VI: BANCO PROFESIONAL DE 25 PROYECTOS SOCIALES ACTUALES',
    icon: <Wallet className="text-orange-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-166" />,
    color: 'bg-orange-100',
    items: ['Desigualdad socioeconómica', 'Territorio y oportunidades educativas', 'Participación ciudadana juvenil', 'Género y representación social', 'Movilidad urbana', 'Trabajo juvenil', 'Cultura digital', 'Consumo informativo', 'Y muchos más'],
    note: 'Cada proyecto incluye: ✔ Problema ✔ Hipótesis ✔ Instrumentos ✔ Análisis modelo ✔ Conclusión profesional'
  }, {
    title: 'BONOS INCLUIDOS',
    icon: <Gift className="text-pink-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-167" />,
    color: 'bg-pink-100',
    items: ['Banco Profesional de Proyectos Sociales', 'Planificación Anual Lista', 'Orientaciones pedagógicas', 'Sistema de evaluación completo']
  }];
  return <section id="que-incluye" className="py-8 sm:py-16 bg-white relative overflow-hidden" data-id="element-168">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5" data-id="element-169">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-blue-600 rounded-full blur-3xl" data-id="element-170"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-purple-600 rounded-full blur-3xl" data-id="element-171"></div>
      </div>

      <div className="max-w-4xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-172">
        <div className="text-center mb-8 sm:mb-12" data-id="element-173">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-174">
            ¿Qué incluye el{' '}
            <span className="text-[#f59e0b]" data-id="element-175">
              KIT COMPLETO METODOLOGÍA DE LA INVESTIGACIÓN
            </span>
            ?
          </h2>
        </div>

        <div className="flex flex-col gap-3 sm:gap-4 mb-8 sm:mb-12" data-id="element-176">
          {blocks.map((block, index) => {
          const isOpen = openIndex === index;
          const isBonus = index === blocks.length - 1;
          return <div key={index} className={`bg-gray-50 border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 shadow-sm ${isOpen ? 'ring-2 ring-[#f59e0b] ring-opacity-50' : 'hover:border-gray-300'}`} data-id="element-177">
                <button onClick={() => toggleAccordion(index)} className="w-full flex items-center justify-between p-4 sm:p-5 text-left focus:outline-none" data-id="element-178">
                  <div className="flex items-center gap-3 sm:gap-4" data-id="element-179">
                    <div className={`${block.color} w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0`} data-id="element-180">
                      {block.icon}
                    </div>
                    <h3 className="text-xs sm:text-base font-bold text-gray-900" data-id="element-181">
                      {block.title}
                    </h3>
                  </div>
                  <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-182" />
                </button>

                <AnimatePresence data-id="element-183">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-184">
                      <div className="px-4 sm:px-5 pb-4 sm:pb-5 pt-0 border-t border-gray-100" data-id="element-185">
                        {isBonus ? <div className="flex flex-wrap gap-2 sm:gap-3 mt-4" data-id="element-186">
                            {block.items.map((item, i) => <span key={i} className="bg-white border border-[#fcd34d] text-gray-800 text-xs sm:text-sm px-3 py-1 rounded-full font-medium shadow-sm" data-id="element-187">
                                {item}
                              </span>)}
                          </div> : <>
                            <ul className="space-y-2 mt-4" data-id="element-188">
                              {block.items.map((item, i) => <li key={i} className="text-gray-600 text-xs sm:text-sm flex items-start" data-id="element-189">
                                  <span className="mr-2 text-[#f59e0b] mt-0.5" data-id="element-190">
                                    •
                                  </span>
                                  <span data-id="element-191">{item}</span>
                                </li>)}
                            </ul>
                            {block.note && <div className="mt-4 p-3 bg-[#fef3c7] rounded-lg border border-[#fcd34d]" data-id="element-192">
                                <p className="text-xs sm:text-sm text-gray-800 font-medium" data-id="element-193">
                                  {block.note}
                                </p>
                              </div>}
                          </>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center" data-id="element-194">
          <button onClick={scrollToOffer} className="inline-flex items-center justify-center bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-lg font-bold py-3 sm:py-4 px-6 sm:px-10 rounded-full shadow-lg transition-all transform hover:scale-105" data-id="element-195">
            📚 ¡Quiero organizar mi año ahora!
          </button>
        </div>
      </div>
    </section>;
}